import { render, staticRenderFns } from "./StudentClass.vue?vue&type=template&id=7b3c872e"
import script from "./StudentClass.vue?vue&type=script&lang=js"
export * from "./StudentClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports